module.exports = __webpack_public_path__ + "img/org.e013adbe.svg";